module.exports = __webpack_public_path__ + "img/Celloger Pro_2.18b2aebe.png";